import { Component, OnInit } from '@angular/core';
import { BciWkModalService } from '@bci/webkitbci';
import { AppStore } from 'src/app/core';

@Component({
  selector: 'app-modal-no-visits',
  templateUrl: './modal-no-visits.component.html',
  styleUrls: ['./modal-no-visits.component.scss'],
  standalone: false
})
export class ModalNoVisitsComponent implements OnInit {
  constructor(private modal: BciWkModalService, private appStore: AppStore) {}

  ngOnInit(): void {
    this.modal.setStyles({
      containerStyle: {
        maxWidth: '600px',
        width: '100%',
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: '16px',
        overflowY: 'hidden',
      },
    });
  }

  close(): void {
    this.modal.close();
  }

  backToSchedule() {
    if (this.appStore.env && this.appStore.origin) {
      const dashboardUrl = `${this.appStore.env.redirects.urlBase}/${this.appStore.origin}/agendamiento-sucursal/agendar`;

      window.parent.location.href = dashboardUrl;
      this.close();
    }
  }
}
